export default (function (event) {
    return event.altKey || event.ctrlKey || event.shiftKey || event.metaKey;
});



//////////////////
// WEBPACK FOOTER
// ./~/@reecelucas/react-use-hotkeys/esm/helpers/modifierKeyPressed.js
// module id = 659
// module chunks = 0